import appConfig from '../../../config/appConfig';

var config = {
  listUrl: appConfig.apiUrl + 'stocktaking/list',
  detailsUrl: appConfig.apiUrl + 'stocktaking/',
  finishUrl: appConfig.apiUrl + 'stocktaking/',
  cancelUrl: appConfig.apiUrl + 'stocktaking/',
  downloadUrl: appConfig.apiUrl + 'stocktaking/download/',
};

export default config;



// WEBPACK FOOTER //
// ./src/components/stocktaking/config/stocktakingConfig.js